export default __webpack_public_path__ + "static/media/dg-girl.8877e276.webp";